import { ConfigProvider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch, useLocation } from "react-router-dom";
import PageNotFound from "../components/PageNotFound/PageNotFound";
import { AUTHENTICATED_ROUTE_OPTIONS } from "../constants/Roles";
import ContactUs from "../containers/ContactUs";
import EnterOTP from "../containers/EnterOTP";
import ForgetPassword from "../containers/ForgetPassword";
import Login from "../containers/Login";
import PrivacyPolicy from "../containers/PrivacyPolicy";
import Register from "../containers/RegisterVendor/Register";
import ResetPassword from "../containers/ResetPassword";
import SignUp from "../containers/SignUp";
import TermsConditions from "../containers/TermsConditions/TermsConditions";
import AppLocale from "../languageProvider";
import AuthService from "../util/auth.service";
import { authenticatedRoutes, unAuthenticatedRoutes } from "./constant";
import { AuthRoutes, PrivateRoute } from "./helper";

const Routes = () => {
    const role = AuthService.getRole();
    const PrivateRouteList =
        AUTHENTICATED_ROUTE_OPTIONS[role ? "Admin" : "Vendor"];
    const locale = useSelector(({ settings }) => settings.locale);
    const currentAppLocale = AppLocale.find((x) => x.id === locale);

    const location = useLocation();

    const matchRoutes = (routes, path) => {
        return routes[path] ? true : false;
    };
    return (
        <ConfigProvider locale={currentAppLocale.lang.antdLocale}>
            <Switch>
                {PrivateRouteList.map(({ linkTo, ...item }, index) => {
                    return (
                        <PrivateRoute
                            {...item}
                            key={index}
                            exact
                            path={linkTo}
                        />
                    );
                })}
                <AuthRoutes exact path="/" component={Login} />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.SIGN_UP}
                    component={SignUp}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.LOGIN}
                    component={Login}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.FORGET_PASSWORD}
                    component={ForgetPassword}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.ENTEROTP}
                    component={EnterOTP}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.RESET_PASSWORD}
                    component={ResetPassword}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.REGISTER}
                    component={Register}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.PRIVACY_POLICY}
                    component={PrivacyPolicy}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.CONTACT_US}
                    component={ContactUs}
                />
                <AuthRoutes
                    exact
                    path={unAuthenticatedRoutes.TERMS_CONDITIONS}
                    component={TermsConditions}
                />
                {!matchRoutes(unAuthenticatedRoutes, location?.pathname) &&
                    !matchRoutes(authenticatedRoutes, location?.pathname) && (
                        <Route component={PageNotFound} />
                    )}
            </Switch>
        </ConfigProvider>
    );
};

export default Routes;
